import React, { isValidElement } from "react";

// Components
import Image from "../../../overrides/venia-ui/components/Image";

// Styles
import classes from "./bookTableHeader.module.scss";
import Icon from "@Components/Icon";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
export default function Header(_ref) {
  var {
    bookingDone,
    isExtended,
    isOrder,
    isBooking = false,
    goBack,
    title,
    subtitle,
    label,
    image,
    additionalBottomSpace,
    additionalTopPadding,
    favRestaurant
  } = _ref;
  var {
    isMobile
  } = useWindowSize();
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.root, " ").concat(isExtended === true ? classes.extended : isExtended === false ? classes.compressed : "", " ").concat(goBack ? classes.goBack : "", " ").concat(bookingDone ? classes.bookingDone : "", " ").concat(additionalBottomSpace === "double" ? classes.doubleBottomSpace : additionalBottomSpace ? classes.bottomSpace : "", " ").concat(additionalTopPadding && classes.additionalTopPadding, " uk-flex uk-flex-column"),
    style: !isMobile && (isOrder || isBooking) ? {
      maxWidth: "500px",
      height: "10vh"
    } : {}
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-middle uk-width-1-1"
  }, goBack ? /*#__PURE__*/React.createElement(Icon, {
    onClick: goBack,
    name: "icon-arrow-left",
    color: "miscusi-red",
    isCircled: true,
    containerClass: "uk-width-1-5",
    justifyStart: true
  }) : /*#__PURE__*/React.createElement("div", {
    className: "uk-width-2-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "uk-width-3-5 uk-text-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "uk-text-emphasis uk-text-bold uk-text-uppercase uk-margin-remove"
  }, title))) : null, image ? /*#__PURE__*/React.createElement("div", {
    className: classes.contentImage
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi",
    src: image,
    displayPlaceholder: false
  })) : null, subtitle ? /*#__PURE__*/React.createElement("h2", null, subtitle) : null, label ? /*#__PURE__*/React.createElement("span", null, label) : null, isValidElement(favRestaurant) ? favRestaurant : null);
}